// import addReportCy from '../components/reportCy/addReportCy.vue'
// import reportCyList from '../components/reportCy/reportCyList.vue'
// import viewReportCy from '../components/reportCy/viewReportCy.vue'

export default [
    {
        path: 'reportCy/addReportCy',
        component: resolve => require(['@/components/reportCy/addReportCy'],resolve),
        name:"AddReportCy",
        meta:{
            id:'773',
            node:'reportCy',
            url:'addReportCy',
        }
    },
    {
        path: 'reportCy/reportCyList',
        component: resolve => require(['@/components/reportCy/reportCyList'],resolve),
        name:"ReportCyList",
        meta:{
            id:'772',
            node:'reportCy',
            url:'reportCyList',
        }
    },
    {
        path: 'ReportCy/viewReportCy',
        component: resolve => require(['@/components/reportCy/viewReportCy'],resolve),
        name:"ViewReportCy",
        meta:{
            id:'774',
            node:'reportCy',
            url:'viewReportCy',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/reportCy.js